import {useState, useEffect} from "react";
import {  getVoiceConfigurationsList, SaveVoiceConfigs, UpdateVoiceConfigs, DeleteVoiceConfigs } from './../../utils/APIClient'
import { useForm } from "react-hook-form";
import {triggerAlert, ConfirmationAlert} from './../../utils/commonFunctions'
import Modal from 'react-bootstrap/Modal';
import { createThemeData, customStyles } from './../../utils/Constants'
import DataTable, { createTheme } from "react-data-table-component";
const VoiceConfigs = () => {
    document.title = "Callingo | Voice Configurations"
    const { register, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm();
    const [folderList, setfolderList] = useState([])
    const [hide, sethide] = useState(false)
    const [editid, seteditid] = useState()
    const [loading, setLoading] = useState(false);
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Sr.No",
            selector: (row, i) => i,
            cell: (row, i) => i + 1,
        },
        {
            name: "Voice Provider",
            selector: (row) => row.voice_provider,
            cell: row => row.voice_provider,
        },
        {
            name: "Voice Model",
            selector: (row) => row.voice_model,
            cell: row => row.voice_model,
        },
        

        {
            name: "Action",

            cell: row => (
                <div className="col-auto" id="tooltip-container9">
                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => { sethide(true); onloadeddata(row) }}  >
                        <i className="ri-edit-box-line  "></i>   </button>
                    <button className="btn btn-link text-danger btn-lg p-0" onClick={() => { ConfirmationAlert("Do you want to delete Voice Configurations from database", "Delete", () => DeleteFolder(row)); }}>
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
        },

    ]
    const getLLMConfigurations = async () => {
        setLoading(true);
        try {
            let folders = await getVoiceConfigurationsList();
            if (folders.data) {
                setLoading(false);
                if (folders.data) {
                    setfolderList([...folders.data])
                }
            }
        } catch (error) {
            setLoading(false);
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);   
        }
    }
    const submitFolder = async (data) => {
        if(editid){
            try{
            data.folder_id  = editid
            const response = await UpdateVoiceConfigs(data);
            const respdata = response.data;
            if (respdata) {
                triggerAlert('success', '', `Voice Configurations updated successfully` || 'Something went wrong');
                getLLMConfigurations();
                sethide(false)
            }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }else{
            try{
                const response = await SaveVoiceConfigs(data);
                const respdata = response.data;
                if (respdata ) {
                    triggerAlert('success', '', `Voice Configurations created successfully` || 'Something went wrong');
                    getLLMConfigurations();
                    sethide(false)
                }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }
        
    }
    const onloadeddata = (data) => {
        setValue("voice_provider", data.voice_provider)
        setValue("voice_model", data.voice_model)
        seteditid(data.id)
    }
    const DeleteFolder = async (data) => {
        try{
            const response = await  DeleteVoiceConfigs(data.id);
            const respdata = response.data;
            if (response.status === 204) {
                triggerAlert('success', '', `Voice Configurations deleted successfully` || 'Something went wrong');
                getLLMConfigurations();
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    const handlePageChange = page => {
        getLLMConfigurations(page_size, page )
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getLLMConfigurations(newPerPage, page )
        setpage_size(newPerPage);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    useEffect(() => {
        getLLMConfigurations();
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">Voice Configurations</h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="page-title-box mb-3">
                    <button className="btn btn-success  mt-0 page-title-right" onClick={()=> {sethide(true); reset(); seteditid()}} ><i className=" ri-user-add-line"></i> Create Voice Configurations</button>
                    <div className="page-title-left">
                        <div className="app-search">
                            <form>
                                <div className="mb-2 position-relative">
                                    <input type="text" className="form-control border border-dark border-opacity-10" placeholder="Search files..." />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card  ">
                        <div className="card-body">
                           
                            {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                    <DataTable
                        columns={columns}
                        fixedHeader

                        persistTableHead
                        data={folderList}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPages}
                        paginationDefaultPage={page_number}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationPerPage={page_size}
                        
                        theme="solarized"
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    /> }
                            
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={hide} onHide={() => sethide(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Voice Configurations</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(submitFolder)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="folderName" className="form-label">Voice Provider</label>
                            <input
                                type="text"

                                id="folderName"
                                name="folderName"
                                {...register("voice_provider", { required: "Voice Provider is required" })}
                                className="form-control"
                                placeholder="Enter your Voice Provider"
                                autoComplete='off'
                            />
                            {errors.voice_provider && <small className="text-danger d-block mb-2">{errors.voice_provider.message}</small>}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="folderName" className="form-label">Voice Model</label>
                            <input
                                type="text"

                                id="folderName"
                                name="folderName"
                                {...register("voice_model", { required: "Voice Model is required" })}
                                className="form-control"
                                placeholder="Enter your Voice Model"
                                autoComplete='off'
                            />
                            {errors.voice_model && <small className="text-danger d-block mb-2">{errors.voice_model.message}</small>}
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-warning  rounded px-3" onClick={() => sethide(false)}>Cancel</button>
                        <button type="submit" className="btn btn-success  rounded px-3">Save</button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>

    )
}

export default VoiceConfigs;